import styled from 'styled-components';

export const JobListingsListStyles = styled.div`
  .ant-tabs-nav::before {
    border-bottom: none;
  }
`;
